// extracted by mini-css-extract-plugin
var _1 = "x5WYCmB0Oy";
var _2 = "EOqwFMIVit";
var _3 = "BtOx2xmeBS";
var _4 = "wzcXfoD5Fq";
var _5 = "v6kfSmhJCE";
export { _1 as "fullscreen", _2 as "item", _3 as "item_selected", _4 as "menu", _5 as "root" }
